import React from "react";

const InfoPopUp = ({ jsonData, titlesColumnSize, valuesColumnSize }) => {
  var keysArray = [];
  var valuesArray = [];

  Object.keys(jsonData).forEach(function (key) {
    keysArray.push(key);
    valuesArray.push(jsonData[key]);
  });

  const labelWidth =
    (titlesColumnSize / (titlesColumnSize + valuesColumnSize)) * 100 + "%";

  return (
    <div style={{ width: "100%" }}>
      <hr style={{ borderWidth: "3px" }} />
      <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
        <colgroup>
          <col style={{ width: labelWidth }} />
          <col />
        </colgroup>
        <tbody>
          {keysArray.map((key, index) => (
            <tr
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? "#f5f5f5" : "#ffffff",
              }}
            >
              <td
                style={{
                  fontWeight: "bold",
                  fontSize: "13px",
                  padding: "6px 12px",
                  color: "#444",
                  borderBottom: "1px solid #e0e0e0",
                  textAlign: "left",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {key}:
              </td>
              <td
                style={{
                  fontSize: "13px",
                  padding: "6px 12px",
                  color: "#222",
                  borderBottom: "1px solid #e0e0e0",
                  wordBreak: "break-word",
                  textAlign: "left",
                }}
              >
                {valuesArray[index]}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InfoPopUp;
